import { Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import { format } from 'date-fns';

// The verified-badge blue Twitter/X and Instagram both use, so the mark reads
// as the thing people already recognise rather than as Glynt house styling.
export const CERTIFIED_BLUE = '#1D9BF0';

interface ICertifiedBadgeProps {
  certifiedAt?: string | null;
  // Withheld on cross-pool and public surfaces, so the badge renders without it.
  certifiedBy?: string | null;
}

const CertifiedBadge = ({ certifiedAt, certifiedBy }: ICertifiedBadgeProps) => {
  if (!certifiedAt) {
    return null;
  }

  const certifiedOn = format(new Date(certifiedAt), 'yyyy-MM-dd HH:mm:ss');
  const title = certifiedBy
    ? `Certified by ${certifiedBy} on ${certifiedOn}`
    : `Certified on ${certifiedOn}`;

  return (
    <Tooltip placement="top" title={title}>
      <VerifiedIcon
        data-cy="badge-certified"
        sx={{
          color: CERTIFIED_BLUE,
          fontSize: '17px',
          flexShrink: 0,
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
};

export default CertifiedBadge;
